var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckedCircleGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333008 7C0.333008 3.32 3.31967 0.333336 6.99967 0.333336C10.6797 0.333336 13.6663 3.32 13.6663 7C13.6663 10.68 10.6797 13.6667 6.99967 13.6667C3.31967 13.6667 0.333008 10.68 0.333008 7ZM2.79967 7.46667L5.19301 9.86C5.45301 10.12 5.87967 10.12 6.13301 9.86L11.193 4.8C11.453 4.54 11.453 4.12 11.193 3.86C10.933 3.6 10.513 3.6 10.253 3.86L5.66634 8.44667L3.73967 6.52667C3.47967 6.26667 3.05967 6.26667 2.79967 6.52667C2.67484 6.65122 2.60468 6.82032 2.60468 6.99667C2.60468 7.17301 2.67484 7.34211 2.79967 7.46667Z",
    fill: "#00C076"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedCircleGreen);
export default __webpack_public_path__ + "static/media/CheckedCircleGreen.3cc11aaefc0cdc63d7edfdb06adbc1f2.svg";
export { ForwardRef as ReactComponent };